export const COMMON_SET_MAP_LOCATION = 'COMMON_SET_MAP_LOCATION';
export const COMMON_TOGGLE_APP_CLASS = 'COMMON_TOGGLE_APP_CLASS';
export const COMMON_SET_ONLINE = 'COMMON_SET_ONLINE';
export const COMMON_SET_FORECAST_OPEN = 'COMMON_SET_FORECAST_OPEN';
